import React, { useEffect, useState } from "react";
import IconCollection from "../../IconCollection/IconCollection";
import { useDispatch } from "react-redux";
import "./Starter.css"
import axios from "axios";
import toast from "react-hot-toast";
import {  useParams } from "react-router-dom";
import Loader from '../../Component/Loader/Loader';
import { gameSubs, onlyMatchDataUpdate, setOpenStarterModal, submitPlayersAndMatchData, updateTeamOnePlayerPlayingStatus, updateTeamTwoPlayerPlayingStatus } from '../../redux/reducers/playersReducer';
import { baseApi } from '../../urlConfig';

const Starter = ({ matchData, playerPersonalFoulCount, event_team_b_id, actionPlayerId, event_team_a_id, minutes, seconds, quarter, playersReducer, setTeamTwoPlayersPlaying, teamTwoPlayersPlaying, teamOnePlayersPlaying, setTeamOnePlayersPlaying, openStarterModal, setTeamTab, teamTab, isLoadingOne, isLoadingTwo,eventType }) => {
  const token = window.localStorage.getItem("token");

  const [loading, setLoading] = useState(false)
  const [teamOneLastChange, setTeamOneLastChange] = useState(true);
  const [teamTwoLastChange, setTeamTwoLastChange] = useState(true);
  const maxPlayers = eventType === "5x5" ? 5 : 4;
  const isValidPlayingCount = (count) => {
    if (eventType === "5x5") return count === 5;
    return count === 3 || count === 4;
  };
  const { teamOneColor, teamTwoColor } = playersReducer
  useEffect(() => {
    if (matchData?.team_a_rosters) {
      const isPlayerData = [...matchData?.team_a_rosters]?.filter((player) => player.is_Playing === true)
      setTeamOnePlayersPlaying(isPlayerData)
    }
  }, [openStarterModal])
  useEffect(() => {
    if (matchData?.team_b_rosters) {
      const isPlayerData = [...matchData.team_b_rosters].filter((player) => player.is_Playing === true)
      setTeamTwoPlayersPlaying(isPlayerData)
    }
  }, [openStarterModal])
  const handleTeamOnePlayerPlaying = (roster_id, jersey_number) => {
    const playerIndex = teamOnePlayersPlaying.findIndex(player => player.roster_id === roster_id);

    if (playerIndex === -1 && teamOnePlayersPlaying.length < maxPlayers) {

      setTeamOnePlayersPlaying(prevPlayers => [...prevPlayers, { roster_id, jersey_number, is_Playing: true }]);
    } else {

      setTeamOnePlayersPlaying(prevPlayers => {
        const updatedPlayers = prevPlayers.map(player => {
          if (player.roster_id === roster_id) {


            return {
              ...player,
              is_Playing: !player.is_Playing
            };

          }
          return player;
        });

        return updatedPlayers.filter(player => player.is_Playing);
      });
      setTeamOneLastChange(false)
    }
  };

  const [previousTeamOnePlayingStatus, setPreviousTeamOnePlayingStatus] =
    useState(null);
  const [previousTeamTwoPlayingStatus, setPreviousTeamTwoPlayingStatus] =
    useState(null);

  useEffect(() => {
    const previousTeamOnePlayers = matchData?.team_a_rosters && [...matchData?.team_a_rosters]?.filter(
      (player) => player.is_Playing
    );
    setPreviousTeamOnePlayingStatus(previousTeamOnePlayers);
  }, []);
  useEffect(() => {
    const previousTeamTwoPlayers = matchData?.team_b_rosters && [...matchData?.team_b_rosters]?.filter(
      (player) => player.is_Playing
    );
    setPreviousTeamTwoPlayingStatus(previousTeamTwoPlayers);
  }, []);



  const handleTeamTwoPlayerPlaying = (roster_id, jersey_number) => {
    const playerIndex = teamTwoPlayersPlaying.findIndex(player => player.roster_id === roster_id);

    if (playerIndex === -1 && teamTwoPlayersPlaying.length < maxPlayers) {

      setTeamTwoPlayersPlaying(prevPlayers => [...prevPlayers, { roster_id, jersey_number, is_Playing: true }]);
    } else {

      setTeamTwoPlayersPlaying(prevPlayers => {
        const updatedPlayers = prevPlayers.map(player => {
          if (player.roster_id === roster_id) {

            return {
              ...player,
              is_Playing: !player.is_Playing
            };
          }
          return player;
        });

        return updatedPlayers.filter(player => player.is_Playing);
      });
      setTeamTwoLastChange(false)
    }
  };

  const postCancelTeamOneBulkSub = () => {
    setTeamOnePlayersPlaying([...previousTeamOnePlayingStatus])
    setTeamOneLastChange(true);
  };
  const postCancelTeamTwoBulkSub = () => {
    setTeamTwoPlayersPlaying([...previousTeamTwoPlayingStatus])
    setTeamTwoLastChange(true);
  };

  const { eventId } = useParams();
  async function getEventData(token) {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ROOT}/api/get_event/${eventId}/`;
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      throw error; // Re-throw the error to handle it elsewhere if needed
    }
  }


  async function fetchEventData(token) {
    try {
      const eventData = await getEventData(token);

    } catch (error) {

      console.error("Error fetching event data:", error);
    }
  }
  const dispatch = useDispatch();





  const resetTeamOnePlaying = () => {
    if (teamOnePlayersPlaying.length > 0) {
      setTeamOnePlayersPlaying([])
    }
  };

  
  // Call /api/set_starter_bulk/ for a given team and roster id list
  const setStarterBulk = async (t_id, rosterIds) => {
    try {
      const url = `${baseApi}/set_starter_bulk/`;
      const data = new FormData();
      data.append("event_id", matchData.event_id);
      data.append("eg_id", matchData.event_group_id);
      data.append("t_id", t_id);
      data.append("scorer_id", 1);

      // Append each roster_id as r_ids (multi-value field)
      rosterIds.forEach((r_id) => {
        data.append("r_ids", r_id);
      });

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-TOKEN": token,
        },
        body: data,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message ||
          `Failed to set starter bulk: ${response.status} ${response.statusText}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Error setting starter bulk:", error);
      throw error;
    }
  };

  const postTeamOneBulkSub = async (t_id) => {

    if (isValidPlayingCount(teamOnePlayersPlaying.length)) {
      setLoading(true)
      try {
        const url = `${process.env.REACT_APP_API_ROOT}` + "/api/add_subs_bulk/";

        const data = new FormData();
        data.append("score_timer", minutes * 60 + seconds);
        data.append("event_id", matchData.event_id);
        data.append("eg_id", matchData.event_group_id);
        data.append("t_id", t_id);
        data.append("score_period", quarter ? quarter : 'NotStarted');

        if (previousTeamOnePlayingStatus.length > 0) {

          let hasSameId = false;
          previousTeamOnePlayingStatus.forEach((player, index) => {
            data.append(`r_id_${index + 1}_org`, player.roster_id);
          });
          teamOnePlayersPlaying.forEach((player, index) => {
            const orgId = previousTeamOnePlayingStatus[index]?.roster_id;
            const newId = player.roster_id;
            // if (orgId === newId) {
            //   hasSameId = true;
            // }
            data.append(`r_id_${index + 1}_new`, newId);
          });

          // if (hasSameId) {
          //   setLoading(false);
          //   toast.error('Original and new roster IDs cannot be the same.');
          //   return;
          // }
        } else {

      teamOnePlayersPlaying.forEach((player, index) => {
            data.append(`r_id_${index + 1}_org`, player.roster_id);
          });

          teamOnePlayersPlaying.forEach((player, index) => {
            data.append(`r_id_${index + 1}_new`, player.roster_id);
          });

        }

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 20000);

        fetch(url, {
          method: "POST",
          body: data,
          headers: {
            Authorization: `${token}`,
          },
          signal: controller.signal
        })
          .then((response) => response.json())
          .then(async (data) => {
            clearTimeout(timeoutId);

            // Only on first-time: check if this specific team has any game_subs entries
            const hasExistingGameSubsForTeam = matchData?.game_subs?.some(
              (sub) => sub.t_id === event_team_a_id
            ) || false;
            
            if (!hasExistingGameSubsForTeam) {
              const rosterIds = teamOnePlayersPlaying.map(player => player.roster_id);
              try {
                await setStarterBulk(t_id, rosterIds);
              } catch (error) {
                toast.error("Failed to set starters. Please try again.");
                setLoading(false);
                return;
              }
            }

            dispatch(updateTeamOnePlayerPlayingStatus(teamOnePlayersPlaying));

            dispatch(gameSubs(data.game_data.game_subs));
            setTeamOneLastChange(true)
            toast.success(`Team ${matchData.team_a_short_name} Player Added Successfully`);
            setLoading(false)
          })
          .catch((error) => {
            clearTimeout(timeoutId);
            console.error("Error:", error);
            setLoading(false);
            if (error.name === 'AbortError') {
              toast.error('Request timed out. Please try again.');
            } else {
              toast.error('An error occurred. Please try again.');
            }
          });
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
        toast.error('An error occurred. Please try again.');
      }
    } else {
      toast.error(`Please select Team ${matchData.team_b_short_name} Starter ${eventType === "5x5" ? 5 : "3 or 4"} Players`);
    }
  };



  const resetTeamTwoPlaying = () => {
    if (teamTwoPlayersPlaying.length > 0) {
      setTeamTwoPlayersPlaying([])
    }
  };

  const postTeamTwoBulkSub = async (t_id) => {


    if (isValidPlayingCount(teamTwoPlayersPlaying.length)) {
      setLoading(true)
      try {
        const url = `${process.env.REACT_APP_API_ROOT}` + "/api/add_subs_bulk/";

        const data = new FormData();
        data.append("score_timer", minutes * 60 + seconds);
        data.append("event_id", matchData.event_id);
        data.append("eg_id", matchData.event_group_id);
        data.append("t_id", t_id);
        data.append("score_period", quarter ? quarter : 'NotStarted');

        if (previousTeamTwoPlayingStatus.length > 0) {
          let hasSameId = false;
          previousTeamTwoPlayingStatus.forEach((player, index) => {
            data.append(`r_id_${index + 1}_org`, player.roster_id);
          });
          teamTwoPlayersPlaying.forEach((player, index) => {
            const newId = player.roster_id;
            const orgId = previousTeamTwoPlayingStatus[index]?.roster_id;
            // if (newId === orgId) {
            //   hasSameId = true;
            // }
            data.append(`r_id_${index + 1}_new`, newId);
          });

          // if (hasSameId) {
          //   setLoading(false);
          //   toast.error('Original and new roster IDs cannot be the same.');
          //   return;
          // }
        } else {
          teamTwoPlayersPlaying.forEach((player, index) => {
            data.append(`r_id_${index + 1}_org`, player.roster_id);
          });
          teamTwoPlayersPlaying.forEach((player, index) => {
            data.append(`r_id_${index + 1}_new`, player.roster_id);
          });

        }

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 20000);

        fetch(url, {
          method: "POST",
          body: data,
          headers: {
            Authorization: `${token}`,
          },
          signal: controller.signal
        })
          .then((response) => response.json())
          .then(async (data) => {
            clearTimeout(timeoutId);

            // Only on first-time: check if this specific team has any game_subs entries
            const hasExistingGameSubsForTeam = matchData?.game_subs?.some(
              (sub) => sub.t_id === event_team_b_id
            ) || false;
            
            if (!hasExistingGameSubsForTeam) {
              const rosterIds = teamTwoPlayersPlaying.map(player => player.roster_id);
              try {
                await setStarterBulk(t_id, rosterIds);
              } catch (error) {
                toast.error("Failed to set starters. Please try again.");
                setLoading(false);
                return;
              }
            }

            dispatch(updateTeamTwoPlayerPlayingStatus(teamTwoPlayersPlaying));

            dispatch(gameSubs(data.game_data.game_subs));
            setTeamTwoLastChange(true)
            toast.success(`Team ${matchData.team_b_short_name} Player Added Successfully`);
            setLoading(false)
          })
          .catch((error) => {
            clearTimeout(timeoutId);
            setLoading(false);
            if (error.name === 'AbortError') {
              toast.error('Request timed out. Please try again.');
            } else {
              console.error("Error:", error);
              toast.error('An error occurred. Please try again.');
            }
          });
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
        toast.error('An error occurred. Please try again.');
      }
    } else {
      toast.error(`Please select Team ${matchData.team_b_short_name} Starter ${eventType === "5x5" ? 5 : "3 or 4"} Players`);
    }
  };

  const hexToRgb = (hexColor, opacity = 0.65) => {
    const hex = hexColor.replace(/^#/, '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    const darkerR = Math.max(0, Math.floor(r * 0.6));
    const darkerG = Math.max(0, Math.floor(g * 0.6));
    const darkerB = Math.max(0, Math.floor(b * 0.6));
    const darkerHex = `rgba(${darkerR}, ${darkerG}, ${darkerB}, ${opacity})`;
    return darkerHex;
  };
  const activeTeamOneColor = hexToRgb(teamOneColor);
  const activeTeamTwoColor = hexToRgb(teamTwoColor);

  const handleModalClose = () => {
    if (teamOneLastChange && teamTwoLastChange) {
      dispatch(setOpenStarterModal(false));
    } else {
      if (!teamOneLastChange) {
        toast.error(`Please Save ${matchData.team_a_short_name ? matchData?.team_a_short_name + " " + "Team" : 'Team 1'}  Change`);
      }
      if (!teamTwoLastChange) {
        toast.error(`Please Save ${matchData.team_b_short_name ? matchData?.team_b_short_name + " " + "Team" : 'Team 2'}  Change`);
      }
    }
  };
  const teamOneStartingLineUp = [];


  const handleTeamOnePlayerStartingLineUp = async () => {
    if (isValidPlayingCount(teamOnePlayersPlaying.length)) {

      const is_Playing = matchData?.team_a_rosters?.filter(player =>
        teamOnePlayersPlaying.some(p => p.roster_id === player.roster_id)
      ) || [];
      const is_present = matchData?.team_a_rosters?.filter(player => {
        return player.is_present === true && !teamOnePlayersPlaying.some(p => p.roster_id === player.roster_id);
      }) || [];


      const startingLineupPlayersData = is_Playing.map(player => {
        return {
          r_id: player.roster_id,
          t_id: matchData?.event_team_a_id,
          event_id: matchData?.event_id,
          eg_id: matchData?.event_group_id,
          present: true,
          startinglinup: true,
          play_sec: player?.play_sec || 0,
        }
      })
      const benchPlayersData = is_Playing.map(player => {
        return {
          r_id: player.roster_id,
          t_id: matchData?.event_team_a_id,
          event_id: matchData?.event_id,
          eg_id: matchData?.event_group_id,
          present: true,
          startinglinup: false,
          play_sec: player?.play_sec || 0,
        }
      })

      const formdata = new FormData();
      formdata.append("data", JSON.stringify([
        ...startingLineupPlayersData,
        ...benchPlayersData
      ]));
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
          {
            headers: {
              "Authorization": `${token}`,
            },
          }
        );

        if (response.data.data !== null) {


          dispatch(onlyMatchDataUpdate(response.data.data));

        }
      } catch (error) {
        console.error("Error submitting team one data:", error);
      }
    } else {
      toast.error(`Please select Team ${matchData.team_a_short_name} Stater ${eventType === "5x5" ? 5 : "3 or 4"} Player`);
    }

  };

  const teamTwoStartingLineUp = [];
  const handleTeamTwoPlayerStartingLineUp = async () => {
    if (isValidPlayingCount(teamTwoPlayersPlaying.length)) {
      const is_Playing = matchData?.team_b_rosters?.filter(player =>
        teamTwoPlayersPlaying.some(p => p.roster_id === player.roster_id)
      ) || [];
      const is_present = matchData?.team_b_rosters?.filter(player => {
        return player.is_present === true && !teamTwoPlayersPlaying.some(p => p.roster_id === player.roster_id);
      }) || [];

      const startingLineupPlayersData = is_Playing.map(player => {
        return {
          r_id: player.roster_id,
          t_id: matchData?.event_team_b_id,
          event_id: matchData?.event_id,
          eg_id: matchData?.event_group_id,
          present: true,
          startinglinup: true,
          play_sec: player?.play_sec || 0,
        }
      })
      const benchPlayersData = is_Playing.map(player => {
        return {
          r_id: player.roster_id,
          t_id: matchData?.event_team_b_id,
          event_id: matchData?.event_id,
          eg_id: matchData?.event_group_id,
          present: true,
          startinglinup: false,
          play_sec: player?.play_sec || 0,
        }
      })

      const formdata = new FormData();
      formdata.append("data", JSON.stringify([
        ...startingLineupPlayersData,
        ...benchPlayersData
      ]));
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
          {
            headers: {
              "Authorization": `${token}`,
            },
          }
        );

        if (response.data.data !== null) {


          dispatch(onlyMatchDataUpdate(response.data.data));
        }
      } catch (error) {
        console.error("Error submitting team one data:", error);
      }
    } else {
      toast.error(`Please select Team ${matchData.team_b_short_name} Stater ${eventType === "5x5" ? 5 : "3 or 4"} Player`);
    }

  };
  return (
    <div className={`fixed top-0 z-[60] left-0 right-0 bottom-0 bg-black bg-opacity-35 min-h-screen  justify-center items-center w-full ${openStarterModal ? 'flex' : 'hidden'}`}>
      <div className='max-w-[350px] md:max-w-[900px] h-[90vh]  relative w-full bg-white rounded-lg border-none py-2 md:py-10'>
        <div onClick={() => handleModalClose()} className='absolute right-4 top-4 cursor-pointer'>
          <IconCollection customClass='md:w-6 md:h-6 w-[10px] h-[10px]' name="close" />
        </div>
        <div className='w-full h-auto'>
          <div className='font-bebas text-xl md:text-3xl px-2 md:px-6 pt-1 md:py-4'>
            Starter/Active Players and Substitution
          </div>
          <div className="h-[26px] md:h-[56px] w-full flex justify-center items-center gap-2 md:gap-10 px-0 md:px-12 ">
            <button
              disabled={isLoadingOne}
              onClick={() => setTeamTab("team1")}
              className={`font-rubik  cursor-pointer text-base md:text-xl px-1 md:px-5 py-[2px] md:py-3 ${teamTab == "team1"
                ? "text-primary font-medium"
                : "text-[#7D7D7D] font-normal"
                }`}
            >
              {matchData?.team_a_short_name}
            </button>
            <button
              disabled={isLoadingTwo}
              onClick={() => setTeamTab("team2")}
              className={`font-rubik  cursor-pointer text-base md:text-xl px-1 md:px-5 py-[2px] md:py-3 ${teamTab == "team2"
                ? "text-primary font-medium"
                : "text-[#7D7D7D] font-normal"
                }`}
            >
              {matchData?.team_b_short_name}
            </button>
          </div>
          <div className="w-full h-[1px] bg-[#E8E8E8]"></div>
          <div className="px-1 md:px-12 py-1 md:py-5 pb-0">
            {teamTab === "team1" && (
              <div className="flex flex-col gap-2 md:gap-12">
                <div className="flex flex-col gap-2 md:gap-12 max-h-[calc(90vh-350px)] overflow-y-auto control-page-starter-modal pr-2">
                  <div className="flex flex-col md:flex-row items-center justify-between relative">

                  <p className="text-[#4A4A4A] md:text-[32px] font-bebas">STARTER/ACTIVE</p>


                  <div className="flex gap-2 items-center relative h-[56px] md:h-[148px]">
                    <div className='absolute right-0 flex gap-2 items-center'>

                    {[...Array(maxPlayers)].map((_, index) => (
                           <button className={`relative md:w-[108.26px] w-[44px]   md:h-[148px] h-[60.15px] cursor-pointer `}>
                           <IconCollection
                             name="player-jersey-white"
                             customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                             svgFillColor={teamOneColor}
                           />
                           <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                             {[...Array(5)].map((_, index) => (
                               <div
                                 key={index}
                                 className={`border-[.67px] rounded-full
                               md:w-2 md:h-2 w-[3.25px] h-[3.25px]`
   
                                 }
                               ></div>
                             ))}
                           </div>
                         </button>
                          ))}
                     
                 
                    </div>
                    {teamOnePlayersPlaying.length > 0 &&
                      teamOnePlayersPlaying
                        .filter((player) => player.is_Playing === true)
                        .sort((a, b) => a.jersey_number - b.jersey_number) // Sort players by jersey_number
                        .map((player, i) => (
                          <button
                            key={i}
                            className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                          >
                            <IconCollection
                              name="player-jersey-white"
                              customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                              svgFillColor={teamOneColor}
                            />
                                 {
                            player?.captain && (
                             <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                                 c
                               </div>
                            )
                          }
                            <p
                              className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                            >

                              {player.jersey_number}
                            </p>
                            <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                              {[...Array(5)].map((_, index) => (
                                <div
                                  key={index}
                                  className={`border-[.67px] rounded-full
                            md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                                  style={{
                                    background: index < playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                                      ? actionPlayerId === player.roster_id
                                        ? `white`
                                        : `white`
                                      : actionPlayerId === player.roster_id
                                        ? `transparent`
                                        : `transparent`,
                                    borderColor: index < playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                                      ? actionPlayerId === player.roster_id
                                        ? 'white'
                                        : `white`
                                      : actionPlayerId === player.roster_id
                                        ? `white`
                                        : `white`
                                  }}
                                ></div>
                              ))}
                            </div>
                          </button>
                        ))
                    }

                  </div>
                </div>
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <p className="text-[#4A4A4A] text-xl md:text-[32px] font-bebas">Bench</p>
                  <div className="max-w-[90%] md:max-w-[504px] w-full  flex flex-wrap items-center gap-2 md:gap-4">
                    {matchData?.team_a_rosters && [...matchData?.team_a_rosters]?.sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                      <button
                        // onClick={() => handleTeamOneBulkSubSelect(player.roster_id)}
                        disabled={!player?.is_present}
                        onClick={() => handleTeamOnePlayerPlaying(player.roster_id, player.jersey_number)}
                        className={`w-10 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center disabled:bg-gray-300 `}
                        style={{
                          backgroundColor: player.roster_id && teamOnePlayersPlaying.some(item => item.roster_id === player.roster_id)
                            ? activeTeamOneColor
                            : teamOneColor
                        }}
                      >
                        {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }
                        {player.jersey_number}
                        <div className="flex  gap-[2px] items-center absolute bottom-2">
                          {[...Array(5)].map((_, index) => (
                            <div
                              className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                              style={{
                                background: index < playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                                  ? actionPlayerId === player.roster_id
                                    ? `white`
                                    : `white`
                                  : actionPlayerId === player.roster_id
                                    ? `transparent`
                                    : `transparent`,
                                borderColor: index < playerPersonalFoulCount(event_team_a_id, player?.roster_id)
                                  ? actionPlayerId === player.roster_id
                                    ? 'white'
                                    : `white`
                                  : actionPlayerId === player.roster_id
                                    ? `white`
                                    : `white`
                              }}
                            ></div>
                          ))}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
                </div>
                <div className="h-[48px] md:h-[80px] w-full px-2 md:px-12 border-[#E8E8E8] border-t-[1px] flex justify-between items-center ">
                  <button
                    onClick={() => resetTeamOnePlaying()}
                    className="text-primary font-montserrat text-xs md:text-base font-medium"
                  >
                    Reselect Starter
                  </button>
                  <div className="flex items-center gap-6 max-w-[160px] md:max-w-[440px] w-full justify-end">
                    <button
                      disabled={teamOneLastChange}
                      onClick={() => postCancelTeamOneBulkSub()}
                      className="max-w-[60px] md:max-w-[108px] w-full h-6 md:h-12 rounded flex justify-center items-center bg-[#E8E8E8] font-bebas text-xs md:text-base text-black disabled:text-white disabled:bg-gray-500"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => [postTeamOneBulkSub(matchData?.event_team_a_id), handleTeamOnePlayerStartingLineUp()]}
                      disabled={!isValidPlayingCount(teamOnePlayersPlaying.length) || loading}
                      className="max-w-[60px] md:max-w-[108px] w-full  h-6 md:h-12 rounded flex justify-center items-center bg-primary font-bebas text-xs md:text-base text-light disabled:text-white disabled:bg-gray-500"
                    >
                      {loading ? <Loader /> : 'save'}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {teamTab === "team2" && (
              <div className="flex flex-col gap-2 md:gap-12 ">
                <div className='flex flex-col gap-2 md:gap-12 max-h-[calc(90vh-350px)] overflow-y-auto control-page-starter-modal pr-2'>
                  <div className="flex flex-col md:flex-row items-center justify-between relative">

                  <p className="text-[#4A4A4A] md:text-[32px] font-bebas">STARTER/ACTIVE</p>

                  <div className="flex gap-2 items-center relative h-[56px] md:h-[148px]">
                    <div className='absolute right-0 flex gap-2 items-center'>
                    {[...Array(maxPlayers)].map((_, index) => (
                            <button className='relative max-w-[108.26px] w-full h-[56px] md:h-[148px] cursor-pointer'>
                            <IconCollection
                              name="player-jersey-white"
                              customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                              svgFillColor={teamTwoColor}
                            />
                            <div className="absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center">
                              {[...Array(5)].map((_, index) => (
                                <div
                                  key={index}
                                  className={`border-[.67px] rounded-full
                                md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                                ></div>
                              ))}
                            </div>
                          </button>
                          ))}
                     
                  
                    </div>

                    {teamTwoPlayersPlaying.length > 0 &&
                      teamTwoPlayersPlaying
                        .filter((player) => player.is_Playing === true)
                        .sort((a, b) => a.jersey_number - b.jersey_number) // Sort players by jersey_number
                        .map((player, i) => (
                          <button
                            key={i}
                            className={`relative md:max-w-[108.26px] max-w-[44px]  w-full md:h-[148px] h-[60.15px] cursor-pointer `}
                          >
                            <IconCollection
                              name="player-jersey-white"
                              customClass='md:w-[108.26px] w-[44px] w-full md:h-[148px] h-[60.15px]'
                              svgFillColor={teamTwoColor}

                            />
                                 {
                            player?.captain && (
                             <div className="absolute top-[7px] md:top-[16px] right-4 md:right-[43px] font-bebas text-[8px] md:text-xs bg-white rounded-full md:h-5 md:w-5 h-3 w-3 leading-none flex justify-center items-center">
                                 c
                               </div>
                            )
                          }
                            <p
                              className={`font-bebas md:text-[64px] text-[28px] text-white absolute md:top-[20px] top-[9px] right-0 left-0 text-center `}
                            >
                              {player.jersey_number}
                            </p>
                            <div className='absolute md:top-[115px] top-[46px] right-0 left-0 justify-center flex md:gap-[2px] gap-[.81px] items-center'>
                              {[...Array(5)].map((_, index) => (
                                <div
                                  key={index}
                                  className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                                  style={{
                                    background: index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                                      ? actionPlayerId === player.roster_id
                                        ? `white`
                                        : `white`
                                      : actionPlayerId === player.roster_id
                                        ? `transparent`
                                        : `transparent`,
                                    borderColor: index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                                      ? actionPlayerId === player.roster_id
                                        ? 'white'
                                        : `white`
                                      : actionPlayerId === player.roster_id
                                        ? `white`
                                        : `white`
                                  }}
                                ></div>
                              ))}
                            </div>
                          </button>
                        ))
                    }
                  </div>




                </div>
                <div className="flex flex-col md:flex-row items-center justify-between">
                  <p className="text-[#4A4A4A] text-xl md:text-[32px] font-bebas">Bench</p>
                  <div className="max-w-[90%] md:max-w-[504px] w-full  flex flex-wrap items-center gap-4">
                    {matchData?.team_b_rosters && [...matchData?.team_b_rosters]?.sort((a, b) => a.jersey_number - b.jersey_number).map((player) => (
                      <button
                        // onClick={() => handleTeamTwoBulkSubSelect(player.roster_id)}
                        onClick={() => handleTeamTwoPlayerPlaying(player.roster_id, player.jersey_number)}
                        className={`w-10 md:w-[88px] text-light font-bebas text-lg md:text-[64px] h-10 md:h-[88px] rounded-sm md:rounded-lg flex relative justify-center items-center disabled:bg-gray-300 `}
                        disabled={!player?.is_present}
                        style={{
                          backgroundColor: player.roster_id && teamTwoPlayersPlaying.some(item => item.roster_id === player.roster_id)
                            ? activeTeamTwoColor
                            : teamTwoColor
                        }}

                      >
                        {
                        player?.captain && (
                          <div className="absolute top-[3px] md:top-[3px] text-black right-[16px] md:right-[36px] font-bebas text-[5px] md:text-[8px] bg-white rounded-full md:h-3 md:w-3 h-[6px] w-[6px] leading-none flex justify-center items-center">
                            c
                          </div>
                        )
                      }
                        {player.jersey_number}
                        <div className="flex  gap-[2px] items-center absolute bottom-2">
                          {[...Array(5)].map((_, index) => (
                            <div
                              key={index}
                              className={`border-[.67px] rounded-full md:w-2 md:h-2 w-[3.25px] h-[3.25px]`}
                              style={{
                                background: index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                                  ? actionPlayerId === player.roster_id
                                    ? `white`
                                    : `white`
                                  : actionPlayerId === player.roster_id
                                    ? `transparent`
                                    : `transparent`,
                                borderColor: index < playerPersonalFoulCount(event_team_b_id, player?.roster_id)
                                  ? actionPlayerId === player.roster_id
                                    ? 'white'
                                    : `white`
                                  : actionPlayerId === player.roster_id
                                    ? `white`
                                    : `white`
                              }}
                            ></div>
                          ))}
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
                </div>
                <div className="h-[48px] md:h-[80px] w-full px-2 md:px-12 border-[#E8E8E8] border-t-[1px] flex justify-between items-center">
                  <button
                    onClick={() => resetTeamTwoPlaying()}
                    className="text-primary font-montserrat text-xs md:text-base font-medium"
                  >
                    Reselect Starter
                  </button>
                  <div className="flex items-center gap-6 max-w-[160px] md:max-w-[440px] w-full justify-end">
                    <button
                      disabled={teamTwoLastChange}
                      onClick={() => postCancelTeamTwoBulkSub()}
                      className="max-w-[60px] md:max-w-[108px] w-full h-6 md:h-12 rounded flex justify-center items-center bg-[#E8E8E8] font-bebas text-xs md:text-base text-black disabled:text-white disabled:bg-gray-500"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => [postTeamTwoBulkSub(matchData?.event_team_b_id), handleTeamTwoPlayerStartingLineUp()]}
                      disabled={!isValidPlayingCount(teamTwoPlayersPlaying.length) || loading}
                      className="max-w-[60px] md:max-w-[108px] w-full  h-6 md:h-12 rounded flex justify-center items-center bg-primary font-bebas text-xs md:text-base text-light disabled:text-white disabled:bg-gray-500"
                    >
                      {loading ? <Loader /> : 'save'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Starter;